<!-- eslint-disable vue/valid-v-bind -->
<template>
    <div>
        <img :src="hotPicturesData.filePath"
            alt="">
        <div v-if="hasClickableHotArea()"
            class="linkWrapper">
            <div v-for="(item2, index2) in hotPicturesData.linkList"
                :key="index2"
                :style="'width:' + (100/hotPicturesData.linkList.length) + '%;'">
                <div v-if="hotPicturesData.pageType=='image'"
                    style="width: 100%; height: 100%;">
                    <!-- 未配置第三方 miniAppId 时，沿用原有 H5 或宿主小程序跳转逻辑 -->
                    <div v-if="showOriginalLinkClickArea(item2, index2)"
                        style="width: 100%; height: 100%;"
                        @click="linkTo(item2, hotPicturesData, index2)"></div>
                    <div v-else-if="!miniprogramFlag && loginType === 'wechat'|| !miniprogramFlag && loginType === 'none'"
                        style="width: 100%; height: 100%; position: relative; overflow: hidden">
                        <!-- 配置了第三方小程序 appid 时，使用其 miniAppId 和页面路径 -->
                        <div v-if="hasThirdPartyMiniAppId(index2)">
                            <wx-open-launch-weapp id="launch-btn"
                                :appid="getLinkMiniAppId(index2)"
                                env-version="release"
                                :path="getLinkPath(index2)"
                                :style="{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden' }">
                                <script type="text/wxtag-template">
                                    <style scoped>.btn { position: 'absolute'; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 1000px; color: red; opacity: 0; display: block; background: green;}</style>
                                  <div class="btn" :style="{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, width: '100%', height: height, opacity: 0, background: pink }">{{item2}}</div>
                                </script>
                            </wx-open-launch-weapp>
                        </div>
                        <!-- 未配置第三方小程序 appid 时，再判断是否打开腾讯荟聚小程序 -->
                        <div
                            v-else-if="hotPicturesData.linksArray[index2] && hotPicturesData.linksArray[index2].lookUp && hotPicturesData.linksArray[index2].lookUp === 'TXHJ'">
                            <wx-open-launch-weapp id="launch-btn"
                                :appid="hotPicturesData.linksArray[index2].appId"
                                env-version="release"
                                :path="hotPicturesData.linksArray[index2].url"
                                style="{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, right: 0, bottom: 0, overflow: hidden }">
                                <script type="text/wxtag-template">
                                    <style scoped>.btn { position: 'absolute'; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 1000px; color: red; opacity: 0; display: block; background: green;}</style>
                                  <div class="btn" :style="{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, width: '100%', height: height, opacity: 0, background: pink }">{{item2}}</div>
                                  <!-- <div :style="{width: ((100 / hotPicturesData.linkList.length) * screenWidth) / 100 + 'px',height: '100%', opacity: 0, display: block, color: red, background: green,border: '2px solid black'}">{{item2}}</div> -->
                                </script>
                            </wx-open-launch-weapp>
                        </div>
                        <div v-else>
                            <wx-open-launch-weapp id="launch-btn"
                                :username="hiHonorWxAppId"
                                :env-version="env"
                                :path="item2.slice(1)"
                                style="{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, right: 0, bottom: 0, overflow: hidden }">
                                <script type="text/wxtag-template">
                                    <style scoped>.btn { position: 'absolute'; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 1000px; color: red; opacity: 0; display: block; background: green; }</style>
                                    <div class="btn" :style="{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, width: '100%', height: height, opacity: 0, background: pink }">{{item2}}</div>
                                    <!-- <div :style="{width: ((100 / hotPicturesData.linkList.length) * screenWidth) / 100 + 'px',height: '100%', opacity: 0, display: block, color: red, background: green,border: '2px solid black'}">{{item2}}</div> -->
                                </script>
                            </wx-open-launch-weapp>
                        </div>
                    </div>
                    <div v-else
                        style="width: 100%; height: 100%;"
                        @click="linkTo(item2, hotPicturesData, index2)"></div>
                </div>
                <div v-if="hotPicturesData.pageType=='imageactivity'"
                    style="width: 100%; height: 100%;"
                    @click="handleGetScheme(hotPicturesData)"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { config } from '../../../../api/config';
export default {
  props: {
    hotPicturesData: Object,
    miniprogramFlag: Boolean,
    activityObj: Object,
    loginType: String,
    env: String,
  },
  data() {
    return {
      height: '100%',
      linksArray: [],
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  created() {
    this.screenWidth = window.screen.width;
  },
  mounted() {},
  methods: {
    // 图片楼层点击跳转到下一级活动
    linkTo(item, data, itemIndex) {
      this.$parent.linkTo(item, data, itemIndex);
      if (item) {
        // 埋码事件：点击(专题页)图片楼层
        this.$parent.handleImgThematicActivityProcess(item);
      }
    },
    hasClickableHotArea() {
      // 原有跳转链接与第三方小程序配置分别存储在两个数组中
      const { linkList, linksArray } = this.hotPicturesData;
      // 配置了跳转链接或 miniAppId 时，渲染热区
      return (linkList || []).some((link) => !!link) ||
        (linksArray || []).some((link) => link && link.miniAppId);
    },
    // 判断当前热区是否配置第三方小程序 appid
    hasThirdPartyMiniAppId(index) {
      const linkConfig = this.hotPicturesData.linksArray && this.hotPicturesData.linksArray[index];
      return linkConfig && linkConfig.miniAppId;
    },
    // 判断当前热区是否显示原有 linkTo 点击层
    showOriginalLinkClickArea(item, index) {
      // 已配置第三方 miniAppId 时，优先显示第三方小程序跳转层
      if (this.hasThirdPartyMiniAppId(index)) {
        return false;
      }
      // item 为当前图片热区配置的原始跳转链接
      // 链接是否为 http 或 https 开头的 H5 链接
      const isH5Link = typeof item === 'string' && item.indexOf('http') === 0;
      // 当前处于小程序 WebView，且链接不是 H5 链接
      const isMiniProgramPath = typeof item === 'string' && item.indexOf('http') === -1 && this.miniprogramFlag;
      // 未配置第三方 miniAppId 时，保留原有点击层
      return !item || isH5Link || isMiniProgramPath;
    },
    // 获取当前热区配置的目标小程序 miniAppId
    getLinkMiniAppId(index) {
      const linkConfig = this.hotPicturesData.linksArray && this.hotPicturesData.linksArray[index];
      return linkConfig && linkConfig.miniAppId;
    },
    // 获取当前热区配置的目标小程序页面路径
    getLinkPath(index) {
      const linkConfig = this.hotPicturesData.linksArray && this.hotPicturesData.linksArray[index];
      return (linkConfig && linkConfig.url) || '';
    },
    // 暂时未用到
    handleWxOpenLaunch(item, len) {
      this.$parent.handleWxOpenLaunch(item, len);
      if (item) {
        // 埋码事件：点击(专题页)图片楼层
        this.$parent.handleImgThematicActivityProcess(item);
      }
    },
    // 获取拉起微信小程序的 Scheme 码
    handleGetScheme(data) {
      // 版本 release -> 正式； trial -> 体验
      const version = config.env === 'pro' ? 'release' : 'trial';
      // 要跳转的活动
      const activityCode = data.hrefFirst && data.hrefFirst.activityCode;
      let params = {
        pageId: data.id,
        param: 'activityCode=' + activityCode,
        path: '/pages/webView/activity-web-view',
        version: version,
      };

      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketingH5',
        url: 'projectActivity/projectActivityGetScheme', 
        params,
        success: (res) => {
          const { code, result } = res;
          if (code == 200) {
            // 判断拉起微信小程序
            if (result.scheme.indexOf('weixin') == 0) {
              location.href = result.scheme;
              // 埋码事件：点击(专题页)图片楼层
              this.$parent.handleImgThematicActivityProcess(result.scheme);
            }
          }
        },
      });
    },
  },
};
</script>


<style scoped lang="scss">
.linkWrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
}
img {
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/themaicComponent/hot-pictures.vue